import { SeoMapper } from '@search/router/src';

export const finishingMapper = new SeoMapper('finishingMapper', {
    UNKNOWN: 'UNKNOWN',
    WITHOUT_FINISHING: 'WITHOUT_FINISHING',
    PRE_FINISHING: 'PRE_FINISHING',
    FINE: 'FINE',
    WITH_FURNITURE: 'WITH_FURNITURE'
} as const);
